/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class GuidanceController extends Controller {
  queryParams = ['openSectionId', 'aiContentSegmentIds'];

  @tracked declare openSectionId: string;
  @tracked declare aiContentSegmentIds: string;
}
